/**
 * QuickPay / The Quick PayMe Central Design System
 * Defines all design tokens, standardized colors, button styles, cards, and modal constants.
 */

export const THEME_COLORS = {
  // Brand Colors
  primary: "#0E5A7A",
  primaryHover: "#1B5E7B",
  primaryLight: "#F0F7FA",
  secondary: "#1D7DA8",
  accent: "#F5A623",
  accentHover: "#D97706",
  accentLight: "#FFFBEB",

  // Feedback Colors
  success: "#10B981",
  successLight: "#F0FDF4",
  successText: "#065F46",
  error: "#EF4444",
  errorLight: "#FEF2F2",
  errorText: "#991B1B",
  warning: "#F59E0B",
  warningLight: "#FFFBEB",
  warningText: "#92400E",
  info: "#3B82F6",
  infoLight: "#EFF6FF",
  infoText: "#1E40AF",

  // Neutral Colors
  background: "#F8FAFC",
  surface: "#FFFFFF",
  border: "#E2E8F0",
  borderFocus: "#0E5A7A",
  textPrimary: "#1E293B",
  textSecondary: "#64748B",
  textMuted: "#94A3B8"
};

export const BORDER_RADIUS = {
  sm: "6px",
  base: "8px",   // Inputs & Buttons
  lg: "12px",   // Cards & Tables
  xl: "16px",   // Modals & Drawers
  full: "9999px" // Badges & Avatars
};

export const SHADOWS = {
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 2px 8px rgba(0, 0, 0, 0.04)",
  card: "0 4px 16px rgba(14, 90, 122, 0.06)",
  modal: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  glow: "0 0 0 4px rgba(14, 90, 122, 0.18)"
};

export const BUTTON_STYLES = {
  primary: {
    backgroundColor: THEME_COLORS.primary,
    borderColor: THEME_COLORS.primary,
    color: "#ffffff",
    fontWeight: 600,
    borderRadius: BORDER_RADIUS.base,
    boxShadow: "0 2px 4px rgba(14, 90, 122, 0.2)"
  },
  secondary: {
    backgroundColor: "#ffffff",
    borderColor: THEME_COLORS.border,
    color: THEME_COLORS.textPrimary,
    fontWeight: 500,
    borderRadius: BORDER_RADIUS.base
  },
  destructive: {
    backgroundColor: THEME_COLORS.error,
    borderColor: THEME_COLORS.error,
    color: "#ffffff",
    fontWeight: 600,
    borderRadius: BORDER_RADIUS.base
  },
  destructiveOutline: {
    backgroundColor: "#ffffff",
    borderColor: THEME_COLORS.error,
    color: THEME_COLORS.error,
    fontWeight: 600,
    borderRadius: BORDER_RADIUS.base
  }
};

export const CARD_STYLE = {
  borderRadius: BORDER_RADIUS.lg,
  borderColor: THEME_COLORS.border,
  boxShadow: SHADOWS.card,
  background: THEME_COLORS.surface
};

export const MODAL_STYLE = {
  borderRadius: BORDER_RADIUS.xl,
  overflow: "hidden"
};

export const TABLE_CONFIG = {
  scroll: { x: 880 },
  pagination: {
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
    defaultPageSize: 10
  }
};
